module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6162ffbfe48d4b6c67f0b469f1615ae.png";